/**
 * Notification type registry.
 *
 * Single source of truth for all notification event types.
 * UI reads icon, color, severity, and Vietnamese text from here — never hardcoded.
 *
 * To add a new type:
 *   1. Add a key to NOTIFICATION_TYPES
 *   2. Provide icon (antd icon name string), color, severity, title, descriptionTpl
 *   3. The mapper (notificationMapper.js) and UI pick it up automatically
 */

/* ─── Severity levels ─── */
export const SEVERITY = {
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

/* ─── Severity → color mapping (for icon tint & dot) ─── */
export const SEVERITY_COLOR = {
  [SEVERITY.INFO]: "#1677ff", // antd blue
  [SEVERITY.WARNING]: "#faad14", // antd gold
  [SEVERITY.ERROR]: "#ff4d4f", // antd red
};

/* ─── Type registry ─── */
export const NOTIFICATION_TYPES = {
  NEW_ORDER: {
    type: "NEW_ORDER",
    icon: "ShoppingCartOutlined",
    severity: SEVERITY.INFO,
    color: SEVERITY_COLOR[SEVERITY.INFO],
    title: "Đơn hàng mới",
    // {count} is interpolated by notificationMapper
    descriptionTpl: "{count} đơn hàng mới vừa được tạo",
    toastTpl: "Bạn có {count} đơn hàng mới",
  },
  ORDER_CANCELLED: {
    type: "ORDER_CANCELLED",
    icon: "CloseCircleOutlined",
    severity: SEVERITY.WARNING,
    color: SEVERITY_COLOR[SEVERITY.WARNING],
    title: "Đơn hàng bị hủy",
    descriptionTpl: "{count} đơn hàng vừa bị hủy",
    toastTpl: "Co {count} don hang bi huy",
  },
  ORDER_DELIVERY_FAILED: {
    type: "ORDER_DELIVERY_FAILED",
    icon: "WarningOutlined",
    severity: SEVERITY.ERROR,
    color: SEVERITY_COLOR[SEVERITY.ERROR],
    title: "Giao hàng thất bại",
    descriptionTpl: "{count} đơn hàng giao thất bại",
    toastTpl: "Có {count} đơn hàng giao thất bại",
  },
  LOW_STOCK: {
    type: "LOW_STOCK",
    icon: "WarningOutlined",
    severity: SEVERITY.WARNING,
    color: SEVERITY_COLOR[SEVERITY.WARNING],
    title: "Sắp hết hàng",
    descriptionTpl: "{count} sản phẩm sắp hết hàng",
    toastTpl: "Có {count} sản phẩm sắp hết hàng",
  },
};

/**
 * Look up a type config. Falls back to NEW_ORDER for unknown types.
 */
export function getNotificationType(type) {
  return NOTIFICATION_TYPES[type] || NOTIFICATION_TYPES.NEW_ORDER;
}
